export const whatIsCabelNodes = [
  {
    id: "90.123.29.119",
    type: "default",
    position: { x: 320, y: 200 },
    className: "gateway",
    data: { label: "90.123.29.119" },
    dragHandle: "noDrag",
  },
  {
    id: "126.134.35.41",
    type: "default",
    position: { x: 520, y: 200 },
    className: "gateway",
    data: { label: "126.134.35.41" },
    dragHandle: "noDrag",
  },
  {
    id: "71dd::ad48:7474:3412",
    type: "default",
    position: { x: 320, y: 400 },
    className: "gateway",
    data: { label: "71dd::ad48:7474:3412" },
    dragHandle: "noDrag",
  },
  {
    id: "224.109.172.5",
    type: "default",
    position: { x: 520, y: 400 },
    className: "gateway",
    data: { label: "224.109.172.5" },
    dragHandle: "noDrag",
  },
  {
    id: "159.146.191.67",
    type: "custom",
    position: { x: 725, y: 170 },
    dragHandle: "noDrag",
    className: "server-plain non-draggable",
    data: { label: "159.146.191.67" },
  },
  {
    id: "17.246.37.189",
    type: "input",
    dragHandle: "noDrag",
    position: { x: 725, y: 370 },
    className: "server-plain non-draggable",
    data: { label: "17.246.37.189" },
  },
  {
    id: "26::862:ed1a::1",
    type: "custom",
    position: { x: 120, y: 370 },
    className: "mobil",
    data: { label: "26::862:ed1a::1" },
    dragHandle: "noDrag",
  },
  {
    id: "162.147.249.223",
    type: "custom",
    position: { x: 120, y: 170 },
    className: "PC",
    data: { label: "162.147.249.223" },
    dragHandle: "noDrag",
  },
];
